import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab, Paper, Button, Snackbar, Alert } from '@mui/material';
import ScienceIcon from '@mui/icons-material/Science';

import SimulateEventModal from '../../components/SimulateEventModal';
import InboxTab from './components/InboxTab';
import AlertRulesTab from './components/AlertRulesTab';
import MessageTemplatesTab from './components/MessageTemplatesTab';
import SystemAuditLogTab from './components/SystemAuditLogTab';
import DeliveryChannelsTab from './components/DeliveryChannelsTab';
import { NotificationService } from '../../api/services/notificationService';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
        </div>
    );
}

export default function NotificationSettings() {
    const [tabValue, setTabValue] = useState(0);
    const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });
    const [simulateModalOpen, setSimulateModalOpen] = useState(false);
    const [simulateLoading, setSimulateLoading] = useState(false);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleSimulateEvent = async (eventPayload) => {
        setSimulateLoading(true);
        try {
            const authData = JSON.parse(localStorage.getItem('adminAuth') || '{}');
            const tenantId = authData.tenantId || '1';
            await NotificationService.simulateEvent(eventPayload, tenantId);
            setNotification({ open: true, message: 'Event simulated successfully', severity: 'success' });
            setSimulateModalOpen(false);
        } catch (err) {
            console.error('Failed to simulate event:', err);
            setNotification({ open: true, message: 'Failed to simulate event', severity: 'error' });
        } finally {
            setSimulateLoading(false);
        }
    };

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Typography variant="h4" fontWeight="bold">Notifications & Alerts</Typography>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button 
                        variant="outlined" 
                        startIcon={<ScienceIcon />} 
                        onClick={() => setSimulateModalOpen(true)}
                        sx={{ borderRadius: 2 }}
                    >
                        Simulate Event
                    </Button>
                </Box>
            </Box>

            <Box sx={{ borderBottom: 1, borderColor: '#eaecf0', mb: 3 }}>
                <Tabs value={tabValue} onChange={handleTabChange} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
                    <Tab label="Inbox" />
                    <Tab label="Alert Rules" />
                    <Tab label="Message Templates" />
                    <Tab label="System Audit Log" />
                    <Tab label="Delivery Channels" />
                </Tabs>
            </Box>

            <Box>
                <TabPanel value={tabValue} index={0}>
                    <InboxTab setNotification={setNotification} isActive={tabValue === 0} />
                </TabPanel>

                <TabPanel value={tabValue} index={1}>
                    <AlertRulesTab setNotification={setNotification} isActive={tabValue === 1} />
                </TabPanel>

                <TabPanel value={tabValue} index={2}>
                    <MessageTemplatesTab setNotification={setNotification} isActive={tabValue === 2} />
                </TabPanel>

                <TabPanel value={tabValue} index={3}>
                    <SystemAuditLogTab setNotification={setNotification} isActive={tabValue === 3} />
                </TabPanel>

                <TabPanel value={tabValue} index={4}>
                    <DeliveryChannelsTab setNotification={setNotification} isActive={tabValue === 4} />
                </TabPanel>
            </Box>

            <SimulateEventModal 
                open={simulateModalOpen} 
                onClose={() => setSimulateModalOpen(false)} 
                onSimulate={handleSimulateEvent}
                loading={simulateLoading}
            />

            <Snackbar 
                open={notification.open} 
                autoHideDuration={6000} 
                onClose={() => setNotification({ ...notification, open: false })}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert onClose={() => setNotification({ ...notification, open: false })} severity={notification.severity} sx={{ width: '100%' }}>
                    {notification.message}
                </Alert>
            </Snackbar>
        </Box>
    );
}
